module.exports = {
  INVITATION: 'INVITATION',
  RELINK: 'RELINK',
}
